import { useEffect, useMemo } from "react";
import { useLazyGetCertificateGroupingDetailsForWithoutRatingByIdQuery, useLazyGetCertificateGroupingDetailsForWithRatingByIdQuery, useLazyGetProductDetailsListByProductInformationIdQuery } from "../../../../../../app/services/CertificateGrouping/certificateGroupingApi";
import { useLazyGetDropDownsForProductsAndServicesQuery } from "../../../../../../app/services/productAndService/productAndServiceApi";
import { useLazyGetPeerReviewEvaluationDetailsByIdQuery } from "../../../../../../app/services/selfEvalutionReviewService/selfEvalutionReviewServiceApi";
import { CERTIFICATE_CONFIG, CERTIFICATE_TYPE } from "../util/CertificateTypes";
import { buildCostRows, toNameMap } from "../util/CertificateUtils";

export const useCertificateGroupingView = (productInfoID, typeId) => {
  const config = CERTIFICATE_CONFIG[typeId];

  const [getProducts, productsRes] = useLazyGetProductDetailsListByProductInformationIdQuery();
  const [getWithRating, withRatingRes] = useLazyGetCertificateGroupingDetailsForWithRatingByIdQuery();
  const [getWithoutRating, withoutRatingRes] = useLazyGetCertificateGroupingDetailsForWithoutRatingByIdQuery();
  const [getDropdowns, dropdownRes] = useLazyGetDropDownsForProductsAndServicesQuery();
  const [getPeerReview, peerReviewRes] = useLazyGetPeerReviewEvaluationDetailsByIdQuery();

  useEffect(() => {
    if (!config || !(productInfoID > 0)) return;
    getDropdowns();
    getProducts(productInfoID);
    getPeerReview(productInfoID);
    typeId === CERTIFICATE_TYPE.WITH_RATING ? getWithRating(productInfoID) : getWithoutRating(productInfoID);
  }, [productInfoID, typeId]);

  const detailsRes = typeId === CERTIFICATE_TYPE.WITH_RATING ? withRatingRes : withoutRatingRes;
  const details = detailsRes.data;

  const products = useMemo(
    () => (Array.isArray(productsRes.data) ? productsRes.data : productsRes.data?.data || []),
    [productsRes.data]
  );
  const itemCodeMap = useMemo(() => toNameMap(dropdownRes.data, "Items Codes"), [dropdownRes.data]);
  const userMap = useMemo(() => toNameMap(dropdownRes.data, "Approver List"), [dropdownRes.data]);

  const costRows = useMemo(
    () => (config ? buildCostRows(products, details?.[config.savedListKey], itemCodeMap) : []),
    [products, details, itemCodeMap, config]
  );

  return {
    config,
    products,
    costRows,
    caseOfficerComment: details?.commentFromCaseOfficer ?? "",
    peerReviewerComment: peerReviewRes.data?.peerReviewerComment ?? "",
    approverComment: peerReviewRes.data?.finalApproverComment ?? "",
    peerReviewerName: userMap.get(details?.peerReviewerId) ?? "-",
    approverName: userMap.get(details?.approverId) ?? "-",
    isLoading:
      productsRes.isLoading || detailsRes.isLoading || dropdownRes.isLoading || peerReviewRes.isLoading,
  };
};